import { Flex, Icon, Tooltip } from "@chakra-ui/react";
import React from "react";

import { IconButton } from "../../../components";
import { CallNoteType } from "../../graphql";
import {
  CONTROL_ACTIVE_BG,
  CONTROL_HOVER_BG,
  IconMoreActions,
  IconShowVideo,
} from "./theme";

export type OverflowActionBarProps = {
  isVideoVisible: boolean;
  onCreateClipClick?(): void;
  openNote(type: CallNoteType): () => void;
  showVideo?(): void;
  isExpanded: boolean;
  onToggleExpanded(): void;
};

/**
 * Compact action bar for narrow viewports.
 * Shows ellipsis button (to expand action row) + video button.
 */
const OverflowActionBar: React.FC<OverflowActionBarProps> = ({
  isVideoVisible,
  showVideo,
  isExpanded,
  onToggleExpanded,
}) => {
  return (
    <Flex alignItems="center" gap="1">
      {/* Ellipsis button to toggle expanded action row */}
      <Tooltip label={isExpanded ? "Hide actions" : "More actions"}>
        <IconButton
          icon={<Icon as={IconMoreActions} boxSize="5" />}
          aria-label={isExpanded ? "Hide actions" : "More actions"}
          variant="ghost"
          color="white"
          borderRadius="8px"
          w={10}
          h={10}
          minW={10}
          bg={isExpanded ? "whiteAlpha.300" : "transparent"}
          _hover={{ bg: CONTROL_HOVER_BG }}
          _active={{ bg: CONTROL_ACTIVE_BG }}
          onClick={onToggleExpanded}
        />
      </Tooltip>

      {/* Show Video button (only when video is hidden) */}
      {!isVideoVisible && showVideo && (
        <Tooltip label="Show video">
          <IconButton
            icon={<Icon as={IconShowVideo} boxSize="6" />}
            aria-label="Show video"
            borderRadius="full"
            w={10}
            h={10}
            minW={10}
            color="white"
            bg="transparent"
            _hover={{ bg: CONTROL_HOVER_BG }}
            _active={{ bg: CONTROL_ACTIVE_BG }}
            onClick={showVideo}
          />
        </Tooltip>
      )}
    </Flex>
  );
};

export default OverflowActionBar;
